export default __webpack_public_path__ + "0813393c09f8cdf1f4338d49fc9140fa.png";